import { isRouteErrorResponse, useRouteError } from "react-router"
import { RedOutline } from "./components/elements/red-outline"
import { GenericError } from "./shared/generic-error"
import { getGenericErrorMessages, getRouteErrorMessages } from "./shared/get-error-message"

export function ErrorBoundary() {
  const func = "RootErrorBoundary"

  // Output of useRouteError() will have at least 'data', 'status', and 'statusText' properties, see more in docs:
  // https://reactrouter.com/en/main/utils/is-route-error-response
  const error = useRouteError()
  console.log("💥", { func }, { error })
  const isRouteError = isRouteErrorResponse(error)

  console.log("💥", { func, isRouteError, error })

  const showTechnicalDetails = true // process.env.NODE_ENV === "development"
  const apiCodeToMessage = {
    "FetchOrders.GenericError": "We had a problem fetching the orders 😬",
    "ListRestaurants.GenericError": "We had a problem fetching the restaurants 😬",
    "GetUser.NotFound":
      "We couldn't find you in our system, make sure you are logged in and have access to this restaurant 😬",
  }

  const { userErrorMessage, technicalErrorMessage } = isRouteError
    ? getRouteErrorMessages({ error, apiCodeToMessage })
    : getGenericErrorMessages({ error })

  return (
    <div className="flex justify-center">
      <div className="mx-6 prose">
        <div className="h-20 sm:h-28" />
        <GenericError message={userErrorMessage} />

        {showTechnicalDetails ? (
          <>
            <div className="h-10" />
            <RedOutline>
              <h4>Technical details</h4>
              <pre className="max-w-80 whitespace-pre-wrap sm:max-w-full">
                {technicalErrorMessage}
              </pre>
            </RedOutline>
            <div className="h-2" />
          </>
        ) : null}
      </div>
    </div>
  )
}
